import React from 'react'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'

const StoreLogo = compose(
  muiThemeable(),
)(
  ({
    logo,
    muiTheme: { palette, appBar, },
    onClick,
    style,
  }) => {
    return (
      <div
        style={{
          backgroundColor: palette.primary2Color,
          ...style,
        }}
        onClick={onClick}
      >
        <img
          src={logo}
          style={{
            display: 'block',
            maxHeight: appBar.height,
            padding: 8,
            margin: 'auto',
          }}
        />
      </div>
    )
  }
)

StoreLogo.propTypes = {
  logo: PropTypes.string.isRequired,
}

export default StoreLogo


// WEBPACK FOOTER //
// ./src/components/images/StoreLogo.js